module.exports = __webpack_public_path__ + "img/3KG.e5830567.jpg";